import api from '../../../services/api';

/**
 * Fetch documents for a specific RFP
 */
export const fetchRFPDocuments = async (rfpId) => {
    return api.get(`/extraction/v1/documents/${rfpId}`);
};

/**
 * Fetch documents assigned to the current employee
 */
export const fetchMyDocuments = async () => {
    return api.get(`/rfp/employee/v1/my-documents`);
};

/**
 * Remove access for a specific user to a document
 */
export const removeDocumentAccess = async (rfpId, docId, userId) => {
    return api.delete(`/extraction/v1/${rfpId}/documents/${docId}/access`, { data: { user_id: userId } });
};

/**
 * Delete a document from storage
 */
export const deleteDocument = async (rfpId, docId) => {
    return api.delete(`/storage/v1/${rfpId}/documents/${docId}`);
};

/**
 * Update document access matrix (Bulk update)
 */
export const updateMatrixAccess = async (rfpId, payload) => {
    return api.post(`/extraction/v1/${rfpId}/documents/matrix-access`, payload);
};

/**
 * Upload enrichment/supporting document
 */
export const uploadEnrichmentDocument = async (rfpId, formData) => {
    return api.post(`/extraction/v1/${rfpId}/upload-enrichment`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

/**
 * Download RFP report
 */
export const downloadRFPReport = async (rfpId, format, language) => {
    return api.post(`/rfp/report/${rfpId}?format=${format}&language=${language}`, {}, {
        responseType: 'blob',
        headers: {
            'Accept-Language': language,
            'language': language
        }
    });
};

/**
 * Bulk Download RFP Reports as ZIP
 * POST /rfp/report/bulk-download
 */
export const bulkDownloadReports = async ({
    rfp_ids,
    format = 'pdf',
    language = 'en',
    theme = 'default',
    template_id = 'default'
}) => {
    const payload = {
        rfp_ids: Array.isArray(rfp_ids) ? rfp_ids : [rfp_ids],
        format,
        language,
        theme,
        template_id
    };

    return api.post('/rfp/report/bulk-download', payload, {
        responseType: 'blob'
    });
};

